import { c as _c } from "react/compiler-runtime";
import type { GetOrgPlaybooksData } from '@onefootprint/request-types/dashboard';
import { useRouter } from 'next/router';
import { parseAsArrayOf, parseAsBoolean, parseAsInteger, parseAsString, useQueryStates } from 'nuqs';
export type PlaybooksConfigQuery = {
  hideDisabled: boolean;
  id: string;
  kinds: string[];
  page: number;
  search: string;
  showFilters: boolean;
};
const defaultQueryParams: PlaybooksConfigQuery = {
  hideDisabled: true,
  id: '',
  kinds: [],
  page: 0,
  search: '',
  showFilters: false
};
const usePlaybooksQueryParams = () => {
  const $ = _c(22);
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      hide_disabled: parseAsBoolean.withDefault(defaultQueryParams.hideDisabled),
      show_filters: parseAsBoolean.withDefault(defaultQueryParams.showFilters),
      id: parseAsString.withDefault(defaultQueryParams.id),
      page: parseAsInteger.withDefault(defaultQueryParams.page),
      search: parseAsString.withDefault(defaultQueryParams.search),
      kinds: parseAsArrayOf(parseAsString).withDefault(defaultQueryParams.kinds)
    };
    t1 = {
      history: "push",
      clearOnDefault: true
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const [queryParams, setQueryParams] = useQueryStates(t0, t1);
  let push;
  let values;
  if ($[2] !== queryParams.hide_disabled || $[3] !== queryParams.id || $[4] !== queryParams.kinds || $[5] !== queryParams.page || $[6] !== queryParams.search || $[7] !== queryParams.show_filters || $[8] !== setQueryParams) {
    push = newQuery => {
      const updated = {
        ...values,
        ...newQuery
      };
      setQueryParams({
        hide_disabled: updated.hideDisabled ?? defaultQueryParams.hideDisabled,
        show_filters: updated.showFilters ?? defaultQueryParams.showFilters,
        id: updated.id ?? defaultQueryParams.id,
        page: updated.page ?? defaultQueryParams.page,
        search: updated.search ?? defaultQueryParams.search,
        kinds: updated.kinds ?? defaultQueryParams.kinds
      });
    };
    values = {
      hideDisabled: queryParams.hide_disabled,
      showFilters: queryParams.show_filters,
      id: queryParams.id,
      page: queryParams.page,
      search: queryParams.search,
      kinds: queryParams.kinds
    };
    $[2] = queryParams.hide_disabled;
    $[3] = queryParams.id;
    $[4] = queryParams.kinds;
    $[5] = queryParams.page;
    $[6] = queryParams.search;
    $[7] = queryParams.show_filters;
    $[8] = setQueryParams;
    $[9] = push;
    $[10] = values;
  } else {
    push = $[9];
    values = $[10];
  }
  const t2 = values.hideDisabled ? "enabled" : undefined;
  const t3 = router.query.kinds as string | undefined;
  let t4;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== values.page || $[14] !== values.search) {
    t4 = {
      page: values.page,
      search: values.search,
      status: t2,
      kinds: t3
    };
    $[11] = t2;
    $[12] = t3;
    $[13] = values.page;
    $[14] = values.search;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const requestParams = t4;
  const hasFilters = values.kinds.length > 0;
  let t5;
  if ($[16] !== hasFilters || $[17] !== push || $[18] !== requestParams || $[19] !== router.isReady || $[20] !== values) {
    t5 = {
      isReady: router.isReady,
      push,
      requestParams,
      values,
      hasFilters,
      filtersCount: values.kinds.length
    };
    $[16] = hasFilters;
    $[17] = push;
    $[18] = requestParams;
    $[19] = router.isReady;
    $[20] = values;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
};
export default usePlaybooksQueryParams;